import { BaseSyntheticEvent, useEffect, useState } from "react"
import { Input } from "../Input/Input"
import Swal from "sweetalert2"
import { ImageLoadingOverlay } from "./ImageLoadingOverlay"
import { i18n } from "../../translate/i18n"
import Modal from 'react-bootstrap/Modal';
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'

type Image = {
    image: string | File
}


type PropsCardImageStore = {
    imagem: Image
    isLoading: boolean
    saveImage: (updatedImage: Image) => void
}

const croppedOptions = [
    { width: 640, height: 240, value: '640x240' },
]

export function CardImageStore({ imagem, isLoading, saveImage }: PropsCardImageStore) {
    const [openModalCropped, setOpenModalCropped] = useState(false)
    const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
    const [imageCrop, setImageCrop] = useState<string | null>('')
    const [isCropped, setCropper] = useState<any>(null)
    const [selectedFormat, setSelectedFormat] = useState<string>('640x240')

    function getImagetoCrop(file: File) {
        setOriginalImageFile(file) // Armazenar arquivo original
        const url = URL.createObjectURL(file)
        setImageCrop(url)
    }

    async function getCropData() {
        if (isCropped) {
            const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
                .then((res) => res.blob())
                .then((blob) => {
                    return new File([blob], 'newAvatar.png', { type: 'image/png' })
                })

            saveImage({ image: file })
            setImageCrop('')
            setOpenModalCropped(false)
        }
    }

    function useOriginalImage() {
        if (originalImageFile) {
            saveImage({ image: originalImageFile })
            setImageCrop('')
            setOpenModalCropped(false)
        }
    }

    function handleSelectedSize(width: number, height: number) {
        if (originalImageFile) {
            // Criar uma cópia do arquivo original com metadados especiais
            const imageWithFormat = Object.assign(originalImageFile, {
                _formatData: {
                    file: originalImageFile,
                    width: width,
                    height: height,
                    isFormatted: true,
                },
            })

            saveImage({ image: imageWithFormat })
            setImageCrop('')
            setOpenModalCropped(false)
        }
    }

    // Mostrar modal apenas quando imageCrop estiver pronto
    useEffect(() => {
        if (imageCrop) {
            setOpenModalCropped(true)
        }
    }, [imageCrop])

    // Limpar blob URL quando desmontar ou quando resetar imageCrop
    useEffect(() => {
        return () => {
            if (imageCrop) {
                URL.revokeObjectURL(imageCrop)
            }
        }
    }, [imageCrop])

    return (
        <>
            <div style={{ position: 'relative' }}>
                <Input
                    inputAttr={{ type: 'image-agregador' }}
                    label={i18n.t('agregador_dinamic_page.form.share_image_label')}
                    smalltext={i18n.t('agregador_dinamic_page.form.share_image_small_text')}
                    width='200'
                    height='100'
                    value={imagem.image}
                    change={(value: BaseSyntheticEvent) => {
                        const file = value ? value.target.files[0] : null;

                        if (!file) {
                            saveImage({ image: file })
                            return;

                        }

                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Erro',
                                text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                            });
                            return;
                        }
                        getImagetoCrop(file)
                    }}
                />
                <ImageLoadingOverlay isLoading={isLoading} />
            </div>
            <Modal show={openModalCropped} onHide={() => setOpenModalCropped(false)}
                size="xl"

                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Body style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
                    <div
                        className={`modal-content`}
                        style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}
                    >
                        <div className='modal-header'>
                            <h5 className='modal-title'>{i18n.t(`smart_order.crop_image`)}</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                onClick={() => setOpenModalCropped(false)}
                            >
                                <i className='fa fa-times' aria-hidden='true'></i>
                            </div>
                        </div>
                        <div
                            className='modal-body text-break pt-4 d-flex justify-content-center flex-grow-1 overflow-auto'
                            style={{ minHeight: '300px' }}
                        >
                            <div className='w-100 d-flex flex-column align-items-center'>
                                <div className='mb-3'>
                                    <Cropper
                                        src={imageCrop ? imageCrop : ''}
                                        style={{ height: '300px', width: '400px', maxWidth: '100%' }}
                                        initialAspectRatio={4 / 3}
                                        minCropBoxHeight={100}
                                        minCropBoxWidth={100}
                                        guides={false}
                                        checkOrientation={false}
                                        onInitialized={(instance: any) => {
                                            setCropper(instance)
                                        }}
                                    />
                                </div>

                                {/* Seleção de formato */}
                                <div className='mb-3'>
                                    <h6 className='text-center mb-2'>
                                        {i18n.t(`smart_order.select_image_format`)}
                                    </h6>
                                    <div className='d-flex justify-content-center gap-3'>
                                        {croppedOptions.map((option) => (
                                            <label className='d-flex align-items-center' key={option.value}>
                                                <input
                                                    type='radio'
                                                    name='imageFormat'
                                                    value={option.value}
                                                    checked={selectedFormat === option.value}
                                                    onChange={(e) => setSelectedFormat(e.target.value)}
                                                    className='me-2'
                                                />
                                                {option.value} ({option.width}x{option.height})
                                            </label>
                                        ))}


                                    </div>
                                </div>

                                {/* Mensagem explicativa sobre o recorte */}
                                <div className='mb-3 text-center'>
                                    <small className='text-muted fst-italic'>
                                        <strong>Dica:</strong> Use "Recortar imagem" apenas quando desejar dar ênfase
                                        a uma parte específica da imagem, destacando melhor a área recortada.
                                    </small>
                                </div>

                                <div className='d-flex justify-content-center flex-wrap gap-2'>
                                    <button className='btn btn-secondary px-3 py-2' onClick={useOriginalImage}>
                                        {i18n.t(`smart_order.use_original_image`)}
                                    </button>
                                    <button className='btn btn-primary px-3 py-2' onClick={() => handleSelectedSize(340, 340)}>
                                        {i18n.t(`smart_order.use_selected_size`)}
                                    </button>
                                    <button className='btn btn-dark px-3 py-2' onClick={getCropData}>
                                        {i18n.t(`smart_order.crop_image`)}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer d-flex justify-content-end border-top pt-3'>
                            <button
                                type='button'
                                className='btn btn-light px-4'
                                onClick={() => setOpenModalCropped(false)}
                            >
                                {i18n.t(`buttons.close`)}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}